import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Chip,
  FormHelperText,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { DoubleArrow, CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import ROUTER from "../../../constants/router";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import KPTimePicker from "../../../components/KPTimePicker";

import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

import { uploadMultiFile } from "../../../reducer/file/action";
import { updateProject, getProfileInfoByProfileId, checkDuplicateProject } from "../../../reducer/project/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { notification } from "../../../reducer/home/action";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";
import DuplicateCheckModal from "../../../components/Project/DuplicateCheckModal";

function ProjectUpdateModal(props) {
  const { updating, setUpdating, updateProject } = props;
  const [disabled, setDisabled] = useState(true);

  const currentYear = getCurrentSchoolYear();
  const [detail, setDetail] = useState(null);

  const [values, setValues] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [fileManagerKey, setFileManagerKey] = useState(0);
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [studentHelperText, setStudentHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(null);

  useEffect(() => {
    if (updating) {
      resetValues();
      // Auto enable edit mode when coming from duplicate check
      if (updating._fromDuplicate) {
        setDisabled(false);
      }
    }
  }, [updating]);

  // Auto-add current user to member list when editing from duplicate check
  useEffect(() => {
    if (updating && updating._fromDuplicate && props.profile?.id) {
      const hasCurrentUser = profileList.some((member) => member.profileId === props.profile.id);

      if (!hasCurrentUser) {
        setProfileList([
          ...profileList,
          {
            profileId: props.profile.id,
            roleInProject: "member",
            isInternal: true,
            externalName: "",
          },
        ]);
      }
    }
  }, [updating, props.profile?.id]);

  // Chọn thành viên để lấy đề tài thì load lại đề tài của ông ấy
  React.useEffect(() => {
    if (values?.profileIdToSelectId) props.getProfileInfoByProfileId(values?.profileIdToSelectId);
  }, [values?.profileIdToSelectId]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  };

  const valueFormat = (value) => {
    const temp = value.replace(/\D/g, "").replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ".");
    return temp;
  };

  const resetValues = () => {
    let _typeToSelectId = "patent";
    let _selectId = updating.patentId;
    if (updating.productContractId > 0) {
      _typeToSelectId = "productContract";
      _selectId = updating.productContractId;
    }
    if (updating.scientificResearchId > 0) {
      _typeToSelectId = "scientificResearch";
      _selectId = updating.scientificResearchId;
    }
    if (updating.solutionId > 0) {
      _typeToSelectId = "solution";
      _selectId = updating.solutionId;
    }
    setValues({
      ...updating,
      startAt: dayjs(updating.startAt)?.format("DD-MM-YYYY")?.replaceAll("-", "/"),
      finishAt: dayjs(updating.finishAt)?.format("DD-MM-YYYY")?.replaceAll("-", "/"),
      acceptedDate: updating.acceptedDate
        ? dayjs(updating.acceptedDate)?.format("DD-MM-YYYY")?.replaceAll("-", "/")
        : null,
      dashboardYear: new Date(dateFormat(updating?.startAt)).getFullYear(),
      // acceptedDay: dayjs(updating.acceptedDay)?.format('DD-MM-YYYY')?.replaceAll('-', '/'),
      // submissionDay: dayjs(updating.submissionDay)?.format('DD-MM-YYYY')?.replaceAll('-', '/'),
      typeToSelectId: _typeToSelectId,
      selectId: _selectId,
      profileIdToSelectId: updating.profileId,
    });

    // Separate students from profiles
    const profiles = [];
    const students = [];

    updating.researchProjectProfile?.forEach((item) => {
      if (item.studentCode) {
        students.push(item);
      } else {
        profiles.push(item);
      }
    });

    setProfileList(profiles || []);
    setStudentList(students || []);
    setFileUrls(updating.fileUrl?.split("||").filter(Boolean) || []);
    setNewFiles([]);
    setFileManagerKey((prev) => prev + 1);

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2022;
    setTimeResearchYear(year);
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInProject: "member",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleChangeStudentList = (index, name, value) => {
    const temp = studentList;
    const tempElm = studentList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setStudentList([...temp]);
  };

  const handleInsertStudent = () => {
    const temp = studentList;
    temp.push({
      studentName: "",
      studentCode: "",
      class: "",
      major: "",
      cohort: "",
      identity: "",
      isInternal: false,
      externalName: "",
      roleInProject: "member",
    });
    setStudentList([...temp]);
  };

  const handleRemoveStudent = (index) => {
    const temp = studentList;
    temp.splice(index, 1);
    setStudentList([...temp]);
  };

  const handleClose = () => {
    if (!disabled) {
      resetValues();
      setDisabled(true);
    } else {
      setUpdating(null);
      setDisabled(true);
      setStudentList([]);
      setFileUrls([]);
      setNewFiles([]);
      setFileManagerKey((prev) => prev + 1);
    }
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
  };

  const checkForDuplicates = async (title, currentId) => {
    if (!title || title.trim() === "") {
      return { hasDuplicates: false, data: [] };
    }

    const result = await props.checkDuplicateProject({
      publicationType: "researchProjects",
      title: title.trim(),
    });

    if (result.success && result.data && result.data.length > 0) {
      // Filter out the current project being edited
      const filteredDuplicates = result.data.filter((item) => item.researchProject?.id !== currentId);

      if (filteredDuplicates.length > 0) {
        return { hasDuplicates: true, data: filteredDuplicates };
      }
    }

    return { hasDuplicates: false, data: [] };
  };

  const handleSelectDuplicate = (item) => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);

    // Switch to editing the selected duplicate
    const projectToEdit = {
      ...item.researchProject,
      researchProjectProfile: item.researchProjectProfile || [],
      _fromDuplicate: true,
    };

    setUpdating(projectToEdit);
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);

    // If user closes modal, proceed with pending submission
    if (pendingSubmit) {
      proceedWithSubmit(pendingSubmit);
      setPendingSubmit(null);
    }
  };

  const proceedWithSubmit = async (submitData) => {
    let finalFileUrl = fileUrls.join("||");
    if (newFiles.length > 0) {
      const uploadResult = await props.uploadMultiFile(submitData.id, newFiles, "researchProject");
      if (uploadResult.success) finalFileUrl = [...fileUrls, ...uploadResult.data].join("||");
    }
    updateProject(submitData.id, { ...submitData, fileUrl: finalFileUrl }).then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
    setUpdating(null);
    setDisabled(true);
  };

  const handleSubmit = async (e) => {
    // check title, code, numOfMember
    if (!values?.title || !values?.numOfMember || values?.numOfMember <= 0) {
      setHelperText(true);
      return;
    }
    e.preventDefault();
    if (disabled) {
      setDisabled(false);
    } else {
      // Validate student list - only if there are students added
      const hasInvalidStudents =
        studentList.length > 0 &&
        studentList.findIndex((e) => e.studentName === "" || e.identity === "" || !e.roleInProject) >= 0;

      if (hasInvalidStudents) {
        setStudentHelperText(true);
        return;
      }

      // Validate at least one internal member
      const hasInternalMember = profileList.some((e) => e.isInternal === true);
      if (!hasInternalMember) {
        props.pushNoti({
          type: "warning",
          message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
        });
        return;
      }

      // Check for duplicates
      // const duplicateCheck = await checkForDuplicates(values?.title, values?.id);

      const submitData = {
        id: values.id,
        ...values,
        researchProjectProfile: [...profileList, ...studentList],
        startAt: dateFormat(values?.startAt),
        finishAt: dateFormat(values?.finishAt),
        acceptedDate: dateFormat(values?.acceptedDate),
        dashboardYear: new Date(dateFormat(values?.startAt)).getFullYear(),
      };

      // if (duplicateCheck.hasDuplicates) {
      //   // Show duplicate modal
      //   setDuplicateList(duplicateCheck.data);
      //   setDuplicateModalOpen(true);
      //   setPendingSubmit(submitData);
      //   return;
      // }

      // No duplicates, proceed with submission
      proceedWithSubmit(submitData);
    }
  };

  const handleOpenUploadModal = () => {};
  const handleCloseUploadModal = () => {};
  const handleOpenPreviewModal = () => {};
  const handleClosePreviewModal = () => {};

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)
  //     ?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter(
  //   (e) => !e.allowedUpdateNum && e.type?.includes("researchProject")
  // );
  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type?.includes("researchProject"));
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const selectList = [];
  if (values?.typeToSelectId) {
    props[values?.typeToSelectId + "s"].forEach((e) => selectList.push(e[values?.typeToSelectId]));
  }

  const renderLockButton = () => {
    if (!values?.locked) return null;
    return (
      <Chip
        variant="outlined"
        label={`Đã khóa tính ${
          (values?.locked === "kpi" && "KPI") ||
          (values?.locked === "reward" && "thưởng") ||
          (values?.locked === "timeResearch" && "giờ nghiên cứu")
        }`}
        color="primary"
        style={{ fontSize: 15, float: "right", marginRight: 16 }}
      />
    );
  };

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Phản hồi về việc khai báo thông tin Công bố khoa học",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "project",
      },
    });
  };

  return (
    <Dialog fullWidth keepMounted maxWidth="lg" open={updating !== null} onClose={handleClose} disableBackdropClick>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {disabled ? "Chi tiết" : "Cập nhật"}
          {renderLockButton()}
        </DialogTitle>
        <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
          <div style={{ flex: "1 1 auto", minWidth: 0, paddingRight: 16 }}>
            <Grid container alignItems="flex-start" spacing={2} style={{ marginBottom: 10 }}>
              <Grid item xs={7}>
                <TextField
                  fullWidth
                  disabled={disabled}
                  size="small"
                  variant="outlined"
                  label="Tên đề tài"
                  required
                  value={values?.title || ""}
                  error={helperText && !values?.title}
                  helperText={helperText && !values?.title ? "Vui lòng nhập tên đề tài" : ""}
                  onChange={(event) => handleChangeForm("title", event.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  disabled={disabled}
                  size="small"
                  variant="outlined"
                  label="Mã CTKH"
                  value={values?.hemisCode || ""}
                  onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  disabled={disabled}
                  size="small"
                  type="number"
                  variant="outlined"
                  label="Số lượng thành viên"
                  value={values?.numOfMember || ""}
                  required
                  error={helperText && !values?.numOfMember}
                  helperText={helperText && !values?.numOfMember ? "Vui lòng nhập số lượng thành viên" : ""}
                  onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  fullWidth
                  size="small"
                  disabled={disabled}
                  options={(props.departmentList || []).filter((d) => d.id !== 0)}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                    null
                  }
                  onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id)}
                  renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
                />
              </Grid>

              {/* <Grid item xs={3}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                variant="outlined"
                label="Mã số"
                value={values?.code || ""}
                required
                error={helperText && !values?.code}
                helperText={helperText && !values?.code ? "Vui lòng nhập mã số" : ""}
                onChange={(event) => handleChangeForm("code", event.target.value)}
              />
            </Grid> */}
              <Grid item xs={6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="type-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Loại hình đề tài
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    disabled={disabled}
                    labelId="type-label"
                    value={values?.type || ""}
                    onChange={(event) => handleChangeForm("type", event.target.value)}
                  >
                    {/* <option value={null} /> */}
                    <option value="basic">Cơ bản</option>
                    <option value="application">Ứng dụng</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="level-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Cấp
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    disabled={disabled}
                    labelId="level-label"
                    value={values?.level || ""}
                    onChange={(event) => handleChangeForm("level", event.target.value)}
                  >
                    {/* <option value={null} /> */}
                    <option value="school">Cơ sở</option>
                    <option value="ministry">Bộ</option>
                    <option value="keyMinistry">Trọng điểm của bộ</option>
                    <option value="nafosted">Nafosted</option>
                    <option value="country">Nhà nước/Quốc gia</option>
                    <option value="city">Tỉnh/TP</option>
                    <option value={null}>Khác</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  rows={2}
                  fullWidth
                  disabled={disabled}
                  multiline
                  size="small"
                  variant="outlined"
                  label="Sản phẩm đăng ký"
                  value={values?.productName || ""}
                  onChange={(event) => handleChangeForm("productName", event.target.value)}
                />
              </Grid>
              <Grid
                item
                xs={3}
                style={{
                  paddingLeft: 18.5,
                  lineHeight: "40px",
                  fontSize: "1em",
                  color: "rgba(0, 0, 0, 0.5)",
                }}
              >
                Thời gian thực hiện:
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Từ ngày"
                  value={values?.startAt || `01/01/${currentYear}`}
                  disabled={disabled}
                  setValue={(newValue) => handleChangeForm("startAt", newValue)}
                />
                {values?.startAt === "dd/mm/yyyy" && (
                  <FormHelperText error>Vui lòng điền thời gian thực hiện!</FormHelperText>
                )}
                {/* <TextField
                fullWidth
                disabled={disabled}
                size='small'
                type='date'
                variant='outlined'
                label='Từ ngày'
                value={values?.startAt || moment().format("YYYY-MM-DD")}
                onChange={(event) => handleChangeForm('startAt', event.target.value)}
              /> */}
              </Grid>
              <Grid item xs={1} style={{ textAlign: "center" }}>
                <DoubleArrow style={{ fontSize: 40, color: "rgba(0, 0, 0, 0.30)" }} />
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Đến ngày"
                  value={values?.finishAt || `01/01/${currentYear}`}
                  disabled={disabled}
                  setValue={(newValue) => handleChangeForm("finishAt", newValue)}
                />
                {values?.finishAt === "dd/mm/yyyy" && (
                  <FormHelperText error>Vui lòng điền thời gian thực hiện!</FormHelperText>
                )}
                {/* <TextField
                fullWidth
                disabled={disabled}
                size='small'
                type='date'
                variant='outlined'
                label='Đến ngày'
                value={values?.finishAt || moment().format("YYYY-MM-DD")}
                onChange={(event) => handleChangeForm('finishAt', event.target.value)}
              /> */}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  fullWidth
                  disabled={disabled}
                  size="small"
                  variant="outlined"
                  label="Cơ quan chủ trì"
                  value={values?.host || ""}
                  onChange={(event) => handleChangeForm("host", event.target.value)}
                >
                  <MenuItem value={"cmc"}>Trường Đại học CMC</MenuItem>
                  <MenuItem value={"other"}>Đơn vị khác</MenuItem>
                  <MenuItem value={"other"}>CMC ATI</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  disabled={disabled}
                  size="small"
                  variant="outlined"
                  label="Cơ quan tài trợ"
                  value={values?.sponsor || ""}
                  onChange={(event) => handleChangeForm("sponsor", event.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  disabled={disabled}
                  size="small"
                  variant="outlined"
                  label="Giá trị"
                  value={values?.value || ""}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">VND</InputAdornment>,
                  }}
                  onChange={(event) => handleChangeForm("value", valueFormat(event.target.value))}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth disabled={disabled} variant="outlined" size="small">
                  <InputLabel id="status-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Tình trạng
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    disabled={disabled}
                    labelId="status-label"
                    value={values?.status || ""}
                    onChange={(event) => handleChangeForm("status", event.target.value)}
                  >
                    {/* <option value={null} /> */}
                    <option value="processing">Đang tiến hành</option>
                    <option value="accepted">Đã nghiệm thu</option>
                    <option value="extend">Gia hạn</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Ngày nghiệm thu"
                  value={values?.acceptedDate || `01/01/${currentYear}`}
                  disabled={disabled}
                  setValue={(newValue) => handleChangeForm("acceptedDate", newValue)}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Mục đích
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="purpose-label"
                    disabled={disabled}
                    value={values?.purposeId ?? "none"}
                    onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                  >
                    {props.purposes
                      .filter((e) => e.name !== "bonusCalculated")
                      .map((e, index) => {
                        if (e.name === "timeResearch")
                          return (
                            <option key={e.id} value={e.id}>
                              {e.description}
                            </option>
                          );
                        // if (e.name === "oldPaper")
                        //   return (
                        //     <option key={e.id} value={e.id}>
                        //       Đề tài không phải Phenikaa chủ trì
                        //     </option>
                        //   );
                        return <option hidden key={`hidden-${index}`} />;
                      })}
                  </Select>
                </FormControl>
              </Grid>

              {values?.purposeId === 5 && (
                <>
                  {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    disabled={disabled}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => {
                      setTimeResearchYear(parseInt(event.target.value));
                      handleChangeForm("timeResearchDetailCode", null);
                    }}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      disabled={disabled}
                      label="Nhiệm vụ tính giờ nghiên cứu"
                      variant="outlined"
                      value={values?.timeResearchDetailCode || null}
                      onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                      InputLabelProps={{
                        shrink: !(
                          values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                        ),
                      }}
                      error={!values?.timeResearchDetailCode}
                    >
                      {timeResearchDetailList.length > 0 ? (
                        timeResearchDetailList?.map((e) => (
                          <MenuItem key={e.code} value={e.code}>{`${e.description} - ${e.value}(h)`}</MenuItem>
                        ))
                      ) : (
                        <MenuItem value={null}>Chưa có dữ liệu</MenuItem>
                      )}
                    </TextField>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Ghi chú"
                  variant="outlined"
                  value={values?.note || ""}
                  multiline
                  rows={3}
                  disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                  onChange={(event) => handleChangeForm("note", event.target.value)}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values?.isOvertimeCountable || false}
                      disabled={
                        disabled ||
                        values?.locked === "kpi" ||
                        values?.locked === "reward" ||
                        props.role !== "sudo-admin"
                      }
                      onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                      color="primary"
                    />
                  }
                  label="Tính giờ ngoài quy chế"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Số giờ ngoài quy chế"
                  variant="outlined"
                  value={values?.overtimeHours ?? ""}
                  disabled={
                    disabled ||
                    values?.locked === "kpi" ||
                    values?.locked === "reward" ||
                    props.role !== "sudo-admin" ||
                    !values?.isOvertimeCountable
                  }
                  onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                  inputProps={{
                    min: 0,
                    step: 0.1,
                  }}
                />
              </Grid>

              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>
              <Grid item xs={2}>
                <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
              </Grid>
              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>

              <Grid item xs={12}>
                {profileList.map((e, index) => (
                  <Grid key={`list-${index}`} container spacing={2}>
                    <Grid item xs={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={e.isInternal !== false}
                            disabled={disabled}
                            onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                            color="primary"
                          />
                        }
                        label="Nội bộ"
                      />
                    </Grid>
                    {e.isInternal && (
                      <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                        <Autocomplete
                          disableClearable
                          disabled={disabled}
                          options={props.profileList}
                          getOptionLabel={(option) => option.name}
                          value={props.profileList?.find((profile) => profile.id === e.profileId)}
                          onChange={(event, profile) =>
                            handleChangeProfileList(index, "profileId", parseInt(profile?.id))
                          }
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                          )}
                        />
                      </Grid>
                    )}
                    {!e.isInternal && (
                      <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Tên thành viên"
                          disabled={disabled}
                          value={e?.externalName || ""}
                          onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                        />
                        {helperText && e.externalName === "" && (
                          <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                        )}
                      </Grid>
                    )}
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel id="roleInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                          Vai trò
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          disabled={disabled}
                          labelId="roleInProject-label"
                          value={e?.roleInProject || "main"}
                          onChange={(event) => handleChangeProfileList(index, "roleInProject", event.target.value)}
                        >
                          <option value="main">Chủ nhiệm</option>
                          <option value="secretary">Thư ký</option>
                          <option value="member">Thành viên</option>
                          {/* <option value="mainOther">Chủ nhiệm tính hộ</option>
                        <option value="memberOther">Thành viên tính hộ</option> */}
                        </Select>
                      </FormControl>
                    </Grid>
                    {values?.purposeId === 1 && (
                      <Grid item xs={3}>
                        <FormControl required fullWidth error={!values?.profileIdForKpi}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={disabled}
                            startIcon={
                              typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                              handleChangeForm(
                                "profileIdForKpi",
                                values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính KPI
                          </Button>
                          {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                        </FormControl>
                      </Grid>
                    )}
                    {values?.purposeId === 99999999 && (
                      <Grid item xs={3}>
                        <FormControl required fullWidth error={!values?.profileIdForReward}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            disabled={disabled}
                            style={{ height: 40 }}
                            // disabled={e.profileId === null}
                            startIcon={
                              typeof values?.profileIdForReward === "number" &&
                              values?.profileIdForReward === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              handleChangeForm(
                                "profileIdForReward",
                                values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính thưởng
                          </Button>
                          {!values?.profileIdForReward && (
                            <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={1}>
                      <Button
                        fullWidth
                        disabled={disabled}
                        color="secondary"
                        variant="contained"
                        style={{ height: 40 }}
                        onClick={() => handleRemove(index)}
                      >
                        Xoá
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsert}>
                  Thêm thành viên
                </Button>
              </Grid>

              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>
              <Grid item xs={2}>
                <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Sinh viên</Typography>
              </Grid>
              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>

              <Grid item xs={12}>
                {studentList.map((e, index) => (
                  <Grid key={`student-${index}`} container spacing={2} style={{ marginBottom: 8 }}>
                    <Grid item xs={5}>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên sinh viên"
                        disabled={disabled}
                        value={e?.studentName || ""}
                        error={studentHelperText && e.studentName === ""}
                        onChange={(event) => handleChangeStudentList(index, "studentName", event.target.value)}
                      />
                      {studentHelperText && e.studentName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Mã sinh viên"
                        disabled={disabled}
                        value={e?.studentCode || ""}
                        error={studentHelperText && e.studentCode === ""}
                        onChange={(event) => handleChangeStudentList(index, "studentCode", event.target.value)}
                      />
                      {studentHelperText && e.studentCode === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl
                        required
                        fullWidth
                        variant="outlined"
                        size="small"
                        error={studentHelperText && !e?.roleInProject}
                      >
                        <InputLabel
                          id={`student-roleInProject-label-${index}`}
                          style={{ padding: "0 8px", backgroundColor: "white" }}
                        >
                          Vai trò
                        </InputLabel>
                        <Select
                          native
                          fullWidth
                          disabled={disabled}
                          labelId={`student-roleInProject-label-${index}`}
                          value={e?.roleInProject || "member"}
                          onChange={(event) => handleChangeStudentList(index, "roleInProject", event.target.value)}
                        >
                          <option value="main">Chủ nhiệm</option>
                          <option value="member">Thành viên</option>
                        </Select>
                      </FormControl>
                      {studentHelperText && !e?.roleInProject && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={1}>
                      <Button
                        fullWidth
                        disabled={disabled}
                        color="secondary"
                        variant="contained"
                        style={{ height: 40 }}
                        onClick={() => handleRemoveStudent(index)}
                      >
                        Xóa
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Lớp"
                        disabled={disabled}
                        value={e?.class || ""}
                        onChange={(event) => handleChangeStudentList(index, "class", event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Ngành học"
                        disabled={disabled}
                        value={e?.major || ""}
                        onChange={(event) => handleChangeStudentList(index, "major", event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Khóa"
                        disabled={disabled}
                        value={e?.cohort || ""}
                        onChange={(event) => handleChangeStudentList(index, "cohort", event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Số CMND/CCCD"
                        disabled={disabled}
                        value={e?.identity || ""}
                        onChange={(event) => handleChangeStudentList(index, "identity", event.target.value)}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsertStudent}>
                  Thêm sinh viên
                </Button>
              </Grid>
              <div
                style={{
                  flexDirection: "column",
                  display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
                }}
              >
                <EmploymentContractTable
                  contract={detail}
                  setDetail={setDetail}
                  contractList={contractList}
                  kpiIdForKpi={values?.kpiIdForKpi}
                  contractIdForKpi={values?.contractIdForKpi}
                  handleChangeForm={handleChangeForm}
                  values={values}
                  setValues={setValues}
                />
                <EmploymentContractDetailTable kpi={detail} />
              </div>
            </Grid>
          </div>
          <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
            <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
              File minh chứng
            </Typography>
            <MultiFileManager
              fileUrls={fileUrls}
              setFileUrls={setFileUrls}
              newFiles={newFiles}
              setNewFiles={setNewFiles}
              disabled={disabled}
              key={fileManagerKey}
            />
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "0 24px 8px 24px" }}>
          <Grid container justifyContent={"space-between"}>
            <div />
            <div>
              {props.adminTab && (
                <Button variant="outlined" onClick={handleSendFeedback}>
                  Gửi feedback
                </Button>
              )}
              <Button variant="outlined" color="secondary" onClick={handleClose} style={{ margin: "0 4px" }}>
                Huỷ
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={
                  (!disabled &&
                    ((values?.purposeId === 1 && !(values?.profileIdForKpi && values?.contractIdForKpi)) ||
                      (values?.purposeId === 99999999 && !values?.profileIdForReward) ||
                      (values?.purposeId === 5 && !values?.timeResearchDetailCode))) ||
                  values?.locked
                }
              >
                {disabled ? "Chỉnh sửa" : "Xác nhận"}
              </Button>
            </div>
          </Grid>
        </DialogActions>
      </form>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        onClose={handleCloseDuplicateModal}
        duplicateList={duplicateList}
        onSelectDuplicate={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
  // ----------- //
  scientificResearchs: select(state, "projectReducer", "scientificResearchs"),
  solutions: select(state, "projectReducer", "solutions"),
  patents: select(state, "projectReducer", "patents"),
  productContracts: select(state, "projectReducer", "productContracts"),
});

const mapDispatchToProps = (dispatch) => ({
  updateProject: (id, payload) => dispatch(updateProject(id, payload)),
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  getProfileInfoByProfileId: (id) => dispatch(getProfileInfoByProfileId(id)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  checkDuplicateProject: (payload) => dispatch(checkDuplicateProject(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ProjectUpdateModal));

